<template>
  <v-main>
    <OLoadingDialog :value="isLoading" />
    <MiniParserDialog ref="miniParserDialog" />
    <div>
      <v-toolbar dark color="grey darken-2" style="z-index: 1">
        <v-icon>mdi-business</v-icon>

        <v-toolbar-title class="ml-4">Rawdata Inspector</v-toolbar-title>

        <v-btn icon class="ml-4" @click="openMiniParserOnSelection">
          <v-icon>mdi-window-restore</v-icon>
        </v-btn>

        <v-spacer />

        <v-flex xs8 class="flex-grow-0">
          <v-tabs
            v-model="currentTab"
            right
            dark
            background-color="transparent"
          >
            <v-tab v-for="t in tabItems" :key="t.value" :href="t.value">
              <v-badge
                bordered
                light
                :offset-y="6"
                :value="t.dirty"
                icon="mdi-asterisk"
                color="black"
              >
                {{ t.label }}
              </v-badge>
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-toolbar>

      <div class="pa-0 of-hidden">
        <!-- <div class="oderon-col-3 pa-2">
          <Sidebar :customer="row" @reload="reload" />
        </div> -->
        <!-- <div class="oderon-col-12"> -->
        <v-tabs-items v-model="currentTab" style="width: 100%">
          <v-tab-item class="pa-0" value="input">
            <Input @gotoOutput="currentTab = 'slices'" />
          </v-tab-item>
          <v-tab-item class="pa-0" value="render">
            <Render @openMiniParser="openMiniParser" />
          </v-tab-item>
          <v-tab-item class="pa-0" value="slices">
            <Output @openMiniParser="openMiniParser" />
          </v-tab-item>
          <v-tab-item class="pa-0" value="canSniff">
            <CANSniff />
          </v-tab-item>
          <v-tab-item class="pa-0" value="logs">
            <Logs @openMiniParser="openMiniParser" />
          </v-tab-item>
        </v-tabs-items>
        <!-- </div> -->
      </div>
    </div>
  </v-main>
</template>

<script>
import Input from './Input.vue'
import Output from './Output.vue'
import Render from './Render.vue'
import Logs from './Logs.vue'
import CANSniff from './CANSniff.vue'
import MiniParserDialog from './MiniParserDialog.vue'
import InspectorStore from './InspectorStore.js'
import reformat from 'brush/reformat.js'

export default {
  components: {
    Input,
    Output,
    Render,
    Logs,
    CANSniff,
    MiniParserDialog
  },
  data() {
    return {
      isLoading: false,
      currentTab: null
    }
  },
  computed: {
    tabItems() {
      return InspectorStore.tabItems
    }
  },
  mounted() {
    const route = this.$route
    function get(x) {
      const v = route.query && route.query[x]
      if (v != null) return parseInt(v)
      return null
    }

    const clientId = get('clientId')
    const fromHbId = get('fromHbId')
    const untilHbId = get('untilHbId')
    if (clientId != null && fromHbId != null) {
      this.$router.replace({ query: {} })
      this.$loading(async () => {
        await InspectorStore.fetch({ clientId, fromHbId, untilHbId })
        this.$snack(`Baixado rawdata do módulo ${clientId}`)
      })
    }
  },
  methods: {
    openMiniParserOnSelection() {
      try {
        const str = window.getSelection().toString()
        const hexInput = reformat(str, { bytesPerLine: 32 })
        this.openMiniParser({ hexInput })
      } catch (err) {
        this.$snack(err.message, { color: 'red' })
      }
    },

    openMiniParser({ hexInput }) {
      this.$refs.miniParserDialog.open(hexInput)
    }
  }
}
</script>

<style></style>
